import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-4xl" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading text-primary-800 mb-2" }, " Neighbor Posts "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, " See what's happening in the neighborhood ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New Post ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-wrap gap-2 mb-6" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-3 mb-4\"><div class=\"w-10 h-10 bg-primary-200 rounded-full\"></div><div class=\"flex-1\"><div class=\"h-4 bg-primary-200 rounded w-24 mb-2\"></div><div class=\"h-3 bg-primary-100 rounded w-16\"></div></div></div><div class=\"h-5 bg-primary-200 rounded w-3/4 mb-3\"></div><div class=\"h-4 bg-primary-100 rounded w-full mb-2\"></div><div class=\"h-4 bg-primary-100 rounded w-2/3\"></div>", 4)
const _hoisted_15 = [
  _hoisted_11
]
const _hoisted_16 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_17 = {
  key: 2,
  class: "text-center py-16 bg-white rounded-xl border border-primary-200 shadow-soft"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-16 mx-auto text-primary-300 mb-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-700 mb-2" }, " No posts yet ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500 mb-6" }, " Be the first to share something with your neighbors! ", -1)
const _hoisted_21 = { class: "w-full max-w-2xl" }
const _hoisted_22 = { class: "w-full max-w-2xl max-h-[90vh] overflow-y-auto" }

import { ref, computed, onMounted } from "vue";
import { usePostStore } from "@/stores/posts";
import UserPost from "@/components/posts/UserPost.vue";
import CreatePostForm from "@/components/posts/CreatePostForm.vue";
import PostDetailModal from "@/components/posts/PostDetailModal.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const postStore = usePostStore();
const showCreatePost = ref(false);
const activeCategory = ref("all");
const selectedPost = ref<Post | null>(null);
const loading = ref(true);

const categories = [
  { label: "All", value: "all" },
  { label: "Help Wanted", value: "looking_to_borrow" },
  { label: "For Sale", value: "for_sale" },
  { label: "Free", value: "free" },
  { label: "Services", value: "service_to_offer" },
  { label: "Questions", value: "question" },
  { label: "Social", value: "social" },
  { label: "General", value: "general" },
];

const filteredPosts = computed(() => {
  if (activeCategory.value === "all") {
    return postStore.posts;
  }
  return postStore.posts.filter((p) => p.type === activeCategory.value);
});

const openPost = (post: Post) => {
  selectedPost.value = post;
};

const handlePostCreated = () => {
  showCreatePost.value = false;
  loadPosts();
};

const handleCommentAdded = async (postId: number) => {
  await loadPosts();
  // Update the selected post with fresh data
  selectedPost.value = postStore.posts.find((p) => p.id === postId) || null;
};

const handlePostDeleted = () => {
  selectedPost.value = null;
  loadPosts();
};

const loadPosts = async () => {
  loading.value = true;
  try {
    await postStore.fetch_posts();
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadPosts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreatePost.value = true)),
          class: "mt-4 md:mt-0 inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors shadow-soft"
        }, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (cat) => {
          return _createElementVNode("button", {
            key: cat.value,
            onClick: ($event: any) => (activeCategory.value = cat.value),
            class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-full transition-colors", 
            activeCategory.value === cat.value
              ? 'bg-primary-800 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-100 border border-primary-200'
          ])
          }, _toDisplayString(cat.label), 11, _hoisted_9)
        }), 64))
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "bg-white rounded-xl border border-primary-100 p-5 animate-pulse"
              }, _hoisted_15)
            }), 64))
          ]))
        : (_unref(filteredPosts).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPosts), (post) => {
                return (_openBlock(), _createBlock(UserPost, {
                  key: post.id,
                  post: post,
                  onOpen: openPost
                }, null, 8, ["post"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showCreatePost.value = true)),
                class: "inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors"
              }, " Create a Post ")
            ]))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showCreatePost.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showCreatePost.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(CreatePostForm, {
                onPostCreated: handlePostCreated,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (showCreatePost.value = false))
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (selectedPost.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (selectedPost.value = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(PostDetailModal, {
                post: selectedPost.value,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (selectedPost.value = null)),
                onCommentAdded: handleCommentAdded,
                onPostDeleted: handlePostDeleted
              }, null, 8, ["post"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})